export default {
      id: "arrow_drop-usage",
      viewBox: "0 0 21 11",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#arrow_drop",
      toString: function () {
        return this.url;
      }
    }